import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTaskList = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_1220_17219",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_1220_17219)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M14.2557 19.4999L13.2115 18.4557L15.8115 15.8557L13.2115 13.2557L14.2557 12.2114L16.8558 14.8114L19.4557 12.2114L20.5 13.2557L17.9 15.8557L20.5 18.4557L19.4557 19.4999L16.8558 16.8999L14.2557 19.4999ZM16.2402 10.8364L13.0462 7.64215L14.0903 6.5979L16.2153 8.7229L20.4653 4.4729L21.5095 5.54215L16.2402 10.8364ZM2.5 16.5577V15.0577H11V16.5577H2.5ZM2.5 8.94215V7.44215H11V8.94215H2.5Z",
			fill: "currentColor"
		})
	})]
});
export default SvgTaskList;
